import { HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { MessageTapeRepositoryService } from 'src/app/data/repositories/components/message-tape/message-tape-repository.service'
import { TypeEnvironment } from 'src/app/domain/enums/application/environment.enum'
import { MessageTapeConfig } from 'src/app/domain/interfaces/components/message-tape.interface'
import { TokenService } from 'src/app/infra/auth/token/token.service'
import { environment } from 'src/environments/environment'

const TYPE_ENVIRONMENT = environment.type

@Injectable({ providedIn: 'root' })
export class MessageTapeService {
  private messageTapeRepositoryService: MessageTapeRepositoryService = inject(MessageTapeRepositoryService)
  private tokenService: TokenService = inject(TokenService)

  messageTapeSubject: BehaviorSubject<MessageTapeConfig> = new BehaviorSubject({ message: '', active: false, environment: TYPE_ENVIRONMENT, socketInterrupted: false } as MessageTapeConfig)

  selectedEnvironment: TypeEnvironment = TYPE_ENVIRONMENT

  public getMessageTapeConfig(): void {
    if (this.tokenService.hasToken())
      this.messageTapeRepositoryService.getPublicationNotice().subscribe((res: HttpResponse<any>) => {
        this.messageTapeSubject.next({ message: res.body.value.length ? res.body.value[0].mensagem : '', active: res.body.value.length ? res.body.value[0].ativo : false, environment: this.selectedEnvironment, socketInterrupted: false })
      })
  }

  public setTapeForSocketInterrupted(socketInterrupted: boolean): void {
    this.messageTapeSubject.next({ message: 'Reconectando ao servidor…', active: socketInterrupted, environment: this.selectedEnvironment, socketInterrupted: socketInterrupted })
  }
}
